<form [formGroup]="eigenWoningFG">
    <div *ngIf="eigenWoningen.length > 0" class="row">
        <div formArrayName="eigenWoningen">
            <div *ngFor="let item of eigenWoningen.controls; let i = index"
                 [formGroupName]="i" class="row">
                <div *ngIf="i > 0" class="pt-2 pb-1">
                    <hr class="line-color">
                </div>
                <div class="row col-auto">
                    <div class="row col-auto" formGroupName="adres">
                        <snelstart-ui-text-form-control (change)="saveForm()"
                                                        class="custom-input-100 col-auto"
                                                        formControlName="postcode"
                                                        id="postcode"
                                                        label="Postcode"
                        >
                        </snelstart-ui-text-form-control>
                        <snelstart-ui-number-form-control (change)="saveForm()"
                                                          [decimals]="0"
                                                          class="custom-input-75 col-auto"
                                                          formControlName="huisNummer"
                                                          id="huisNummer"
                                                          label="Huisnr"
                        >
                        </snelstart-ui-number-form-control>
                        <snelstart-ui-text-form-control (change)="saveForm()"
                                                        class="custom-input-75 col-auto"
                                                        formControlName="huisNummerToevoeging"
                                                        id="huisNummerToevoeging"
                                                        label="Toev."
                        >
                        </snelstart-ui-text-form-control>
                        <snelstart-ui-text-form-control (change)="saveForm()"
                                                        class="custom-input-272 col-auto"
                                                        formControlName="woonplaats"
                                                        id="woonplaats"
                                                        label="Woonplaats"
                        >
                        </snelstart-ui-text-form-control>
                    </div>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      align="right"
                                                      class="custom-input-250 col-auto"
                                                      formControlName="woz"
                                                      id="woz"
                                                      label="Woz-waarde 1-1-{{incomeTaxEntity.aangifte?.aangifteJaar! -1}}"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [showAllDecimals]="true"
                                                      align="right"
                                                      class="custom-input-125 col-auto"
                                                      formControlName="percentageEigendom"
                                                      id="percentageEigendom"
                                                      label="Eigendom"
                                                      postfix="%"

                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-button (click)="deleteEigenWoning(i)"
                                         class="pt-3 col"
                                         icon="trash"
                                         iconType="light"
                                         id="buttonDelete"
                                         size="medium"
                                         type="secondary"
                    >
                    </snelstart-ui-button>
                </div>
                <div class="row">
                    <div class="row col-auto" formGroupName="bewoondePeriode">
                        <snelstart-ui-date-form-control (change)="saveForm()"
                                                        class="custom-input-150 col-auto"
                                                        formControlName="begindatum"
                                                        id="begindatum"
                                                        label="Bewoond vanaf"
                                                        placeholder="dd-mm-{{this.aangifte.aangifteJaar}}"
                        >
                        </snelstart-ui-date-form-control>
                        <snelstart-ui-date-form-control (change)="saveForm()"
                                                        class="custom-input-150 col-auto"
                                                        formControlName="einddatum"
                                                        id="einddatum"
                                                        label="Bewoond t/m"
                                                        placeholder="dd-mm-{{this.aangifte.aangifteJaar}}"
                        >
                        </snelstart-ui-date-form-control>
                    </div>
                    <div class="col-auto pt-3">
                        <snelstart-ui-button (click)="this.showDialog(i)"
                                             class="custom-input-200"
                                             icon="plus"
                                             type="secondary">Verkoop/Leegstand?
                        </snelstart-ui-button>
                    </div>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      align="right"
                                                      class="custom-input-250 col-auto"
                                                      formControlName="betaaldeErfpachtCanon"
                                                      id="betaaldeErfpachtCanon"
                                                      label="Betaalde erfpacht"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-select-form-control (change)="saveForm()"
                                                      [options]="optionsJaNeeAanhorigheid"
                                                      class="custom-input-250 col-auto"
                                                      formControlName="aanhorigheid"
                                                      id="aanhorigheid"
                                                      label="Aanhorigheid"
                    >
                    </snelstart-ui-select-form-control>
                </div>
            </div>
        </div>
    </div>


    <div *ngIf="eigenWoningen.length === 0">
        <snelstart-ui-button (click)="addEigenWoning()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Woning invullen
        </snelstart-ui-button>
    </div>
    <div *ngIf="eigenWoningen.length > 0">
        <snelstart-ui-button (click)="addEigenWoning()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Woning toevoegen
        </snelstart-ui-button>
    </div>
</form>

<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="eigenWoningBijzonderheden" size="lg"
                                title="Gegevens verkoop en/of leegstand eigen woning">
    <snelstart-ui-dialog-body>
        <form (change)="saveForm()" [formGroup]="eigenWoningFG">
            <div formArrayName="eigenWoningen">
                <div *ngFor="let woning of eigenWoningen.controls; let i = index; "
                     [formGroupName]="i">
                    <div *ngIf="i === this.index">
                        <div *ngIf="eigenWoningen.controls[i].get('begindatum')?.getRawValue() === null
                                          || eigenWoningen.controls[i].get('einddatum')?.getRawValue() === null"
                             class="row">
                            <div class="col-7 pt-1">
                                <p>Is er in {{ aangifte.aangifteJaar }} sprake van verkoop en/of leegstand van de
                                    woning?</p>
                            </div>
                            <div class="col-5">
                                <snelstart-ui-select-form-control (change)="saveForm()"
                                                                  [options]="redenLeegstand"
                                                                  class="custom-input-250"
                                                                  formControlName="leegstand"
                                >
                                </snelstart-ui-select-form-control>
                            </div>
                        </div>

                        <div *ngIf="eigenWoningen.controls[i].get('leegstand')?.getRawValue() === OnroerendeZaakLeegstand.AANBOUW"
                             class="row">
                            <div class="col-7 pt-1">
                                <p>Is de onroerende zaak gekocht in {{ aangifte.aangifteJaar }}? Vul de aankoopdatum
                                    in</p>
                            </div>
                            <div class="col-5">
                                <snelstart-ui-date-form-control (change)="saveForm()"
                                                                class="custom-input-250"
                                                                formControlName="datumGekocht"
                                                                id="datumGekocht"
                                                                label=""
                                                                placeholder="dd-mm-{{this.aangifte.aangifteJaar}}"
                                >
                                </snelstart-ui-date-form-control>
                            </div>
                        </div>

                        <div *ngIf="eigenWoningen.controls[i].get('datumGekocht')?.getRawValue() !== null" class="row">
                            <div formArrayName="aankoopkosten">
                                <div *ngFor="let ewgroup of getAankoopkosten(i).controls; let j = index "
                                     [formGroupName]="j">
                                    <div class="row col-auto">
                                        <snelstart-ui-text-form-control
                                                (change)="saveForm()"
                                                [label]="j === 0 ? 'Omschrijving aankoop' : ''"
                                                class="custom-input-250"
                                                formControlName="omschrijving"
                                        >
                                        </snelstart-ui-text-form-control>
                                        <snelstart-ui-number-form-control (change)="saveForm()"
                                                                          [decimals]="0"
                                                                          [label]="j === 0 ? 'Aankoopprijs incl. kosten' : ''"
                                                                          align="right"
                                                                          class="custom-input-200"
                                                                          formControlName="bedrag"
                                                                          placeholder=""
                                                                          prefix="€"
                                        >
                                        </snelstart-ui-number-form-control>
                                        <snelstart-ui-button (click)="deleteAankoopkosten(i, j)"
                                                             [class]="j === 0 ? 'pt-3 col-auto' : 'col-auto'"
                                                             icon="trash"
                                                             id="buttonDeleteAankoop"
                                                             size="medium"
                                                             type="secondary"
                                        >
                                        </snelstart-ui-button>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="getAankoopkosten(i).length === 0">
                                <snelstart-ui-button (click)="addAankoopkosten(i)"
                                                     class="snelstart-ui-button pb-3"
                                                     icon="plus"
                                                     type="link">Aankoopprijs en
                                    -kosten invullen
                                </snelstart-ui-button>
                            </div>
                            <div *ngIf="getAankoopkosten(i).length > 0">
                                <snelstart-ui-button (click)="addAankoopkosten(i)"
                                                     class="snelstart-ui-button pb-3"
                                                     icon="plus"
                                                     type="link">Aankoopprijs en
                                    -kosten toevoegen
                                </snelstart-ui-button>
                            </div>
                        </div>
                        <div *ngIf="eigenWoningen.controls[i].get('leegstand')?.getRawValue() === OnroerendeZaakLeegstand.VERKOOP">
                            <div class="row">

                                <div class="col-7 pt-1">
                                    <p>Is de onroerende zaak verkocht in {{ aangifte.aangifteJaar }}? Vul de
                                        verkoopdatum in</p>
                                </div>
                                <div class="col-5">
                                    <snelstart-ui-date-form-control (change)="saveForm()"
                                                                    class="custom-input-250"
                                                                    formControlName="datumVerkocht"
                                                                    id="datumVerkocht"
                                                                    label=""
                                                                    placeholder="dd-mm-{{this.aangifte.aangifteJaar}}"
                                    >
                                    </snelstart-ui-date-form-control>
                                </div>
                            </div>

                            <div *ngIf="eigenWoningen.controls[i].get('datumVerkocht')?.getRawValue() !== null">
                                <div formArrayName="verkoopkosten">
                                    <div *ngFor="let ewgroup of getVerkoopkosten(i).controls; let k = index"
                                         [formGroupName]="k" class="row">
                                        <div class="col-7">
                                            <snelstart-ui-text-form-control (change)="saveForm()"
                                                                            [label]="k === 0 ? 'Omschrijving verkoop' : ''"
                                                                            class="custom-input-275"
                                                                            formControlName="omschrijving"
                                            >
                                            </snelstart-ui-text-form-control>
                                        </div>
                                        <div class="col-5">
                                            <snelstart-ui-number-form-control (change)="saveForm()"
                                                                              [decimals]="0"
                                                                              [label]="k === 0 ? 'Verkoopprijs excl. kosten' : ''"
                                                                              align="right"
                                                                              class="custom-input-272"
                                                                              formControlName="bedrag"
                                                                              placeholder=""
                                                                              prefix="€"
                                            >
                                            </snelstart-ui-number-form-control>
                                        </div>
                                        <!--                                            <snelstart-ui-button (click)="deleteVerkoopkosten(i, k)"-->
                                        <!--                                                                 class="pt-3 col-auto"-->
                                        <!--                                                                 icon="trash"-->
                                        <!--                                                                 iconType="light"-->
                                        <!--                                                                 id="buttonDeleteVerkoop"-->
                                        <!--                                                                 size="medium"-->
                                        <!--                                                                 type="secondary"-->
                                        <!--                                            >-->
                                        <!--                                            </snelstart-ui-button>-->
                                    </div>
                                </div>
                                <div *ngIf="getVerkoopkosten(i).length === 0">
                                    <snelstart-ui-button (click)="addVerkoopkosten(i)"
                                                         class=" pb-3"
                                                         icon="plus"
                                                         type="secondary"
                                    >Vul de verkoopprijs excl. kosten in
                                    </snelstart-ui-button>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-7 pt-3">
                                    <p>Is er een eigenwoningschuld (EWS) bij verkoop?</p>
                                </div>
                                <div class="col-5">
                                    <snelstart-ui-number-form-control
                                            (change)="saveForm()"
                                            [decimals]="0"
                                            align="right"
                                            class="custom-input-250"
                                            formControlName="eigenWoningSchuldVerkochteWoning"
                                            id="eigenWoningSchuldVerkochteWoning"
                                            label="Bedrag eigenwoningschuld bij verkoop"
                                            prefix="€"
                                    >
                                    </snelstart-ui-number-form-control>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
        <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
        <snelstart-ui-button btn-x icon="check" id="save" type="primary">Opslaan</snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

